import { ReactElement, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useCookies } from 'react-cookie';
// import * as Sentry from '@sentry/browser';

import { useAuth } from 'features/auth';
import { Page, Loading } from 'components';
import request from 'app/utils/request';
import { useSchool } from 'features/school';
import { useAlert } from 'features/alert';
import usingStorage from 'app/utils/storage';
import { useSheets } from 'features/dashboard-new';
import { createUrl } from 'app/utils';

const storage = usingStorage('localStorage');

const LogoutView = (): ReactElement => {
  const { clearAuth } = useAuth();
  const { apiGatewayUrl } = useSchool();
  const { setAlert } = useAlert();
  const { setDashboardUsing } = useSheets();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [cookies, setCookie, removeCookie] = useCookies(['token']);

  const [searchParams] = useSearchParams();

  const redirect = searchParams.get('redirect');

  const whenDisconnected = () => {
    clearAuth();
    removeCookie('token', {
      path: '/',
      domain: window.location.hostname,
    });

    storage.remove('currentDashboard');
    setDashboardUsing(null);

    // Sentry.configureScope((scope) => scope.setUser(null));

    if (redirect) {
      window.location.href = redirect;
    } else {
      setAlert({ type: 'warning', message: 'Sua sessão foi finalizada.' });
      window.location.href = createUrl('login');
    }
  };

  useEffect(() => {
    request({
      url: '/api/v1/user/Unauthentication',
      method: 'get',
      baseURL: apiGatewayUrl,
    })
      .then(() => {
        whenDisconnected();
      })
      .catch((error) => {
        whenDisconnected();
      });
  }, []);

  return (
    <Page title="Logout">
      <Loading label="Saindo..." />
    </Page>
  );
};

export default LogoutView;
